if (!customElements.get('hanger-live-preview')) {
  customElements.define('hanger-live-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.root = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.panel = this.querySelector('.hlp-panel');
      this.frame = this.querySelector('iframe');
      this.status = this.querySelector('.hlp-status');
      this.openButton = this.querySelector('.hlp-open');
      this.zoomButton = this.querySelector('.hlp-zoom');
      if (!this.root || !window.HangerPreviewDocument) return;
      this.url = new URL(location.origin);
      this.dataset.ready = 'true';
      const listen = (target, event, fn, options = {}) => target.addEventListener(event, fn, {...options, signal:this.abort.signal});
      const relevant = target => target.closest('[data-option-value],[data-wire-color],input[name^="properties["],select[name^="options["]');
      const refresh = event => {
        const control = relevant(event.target);
        if (!control) return;
        this.activeControl = control;
        if (!this.started || this.panel.hidden) this.show();
        this.position();
        clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(() => {this.send(); this.keepInputVisible();}, 80);
      };
      ['input','change','click','focusin'].forEach(event => listen(this.root,event,refresh));
      listen(this.root,'stitch:gallery-options-updated',()=>this.send());
      listen(this.querySelector('.hlp-close'),'click',()=>{
        this.frame.contentWindow.hangerPreviewZoom?.reset();
        this.panel.hidden=true;this.openButton.hidden=false;this.openButton.focus();
      });
      listen(this.openButton,'click',()=>this.show());
      listen(this.zoomButton,'click',()=>this.frame.contentWindow.postMessage({type:'hanger-preview:toggle-zoom'},this.url.origin));
      listen(this,'keydown',event=>{if(event.key==='Escape'){this.frame.contentWindow.hangerPreviewZoom?.reset();this.panel.hidden=true;this.openButton.hidden=false;this.openButton.focus();}});
      listen(window,'message',event=>{
        if(event.source!==this.frame.contentWindow || event.origin!==this.url.origin) return;
        if(event.data?.type==='hanger-preview:ready') this.send();
        if(event.data?.type==='hanger-preview:updated'){this.status.hidden=true;clearTimeout(this.loadTimer);}
        if(event.data?.type==='hanger-preview:unsupported') this.fail();
        if(event.data?.type==='hanger-preview:zoom') {
          this.zoomButton.classList.toggle('is-zoomed',event.data.zoomed);
          this.zoomButton.setAttribute('aria-label',event.data.zoomed?this.zoomButton.dataset.reset:this.zoomButton.dataset.zoom);
          this.zoomButton.setAttribute('aria-pressed',String(event.data.zoomed));
        }
      });
      listen(this.frame,'load',()=>this.send());
      listen(window,'resize',()=>{this.position();this.keepInputVisible();});
      listen(window,'scroll',()=>this.position(),{passive:true});
      if(window.visualViewport) {
        listen(window.visualViewport,'resize',()=>{this.position();this.keepInputVisible();});
        listen(window.visualViewport,'scroll',()=>this.position());
      }
    }
    value(name) {return this.root.querySelector('[name="'+name+'"]')?.value || '';}
    send() {
      if(!this.started) return;
      const options=Array.from(this.root.querySelectorAll('[name^="options["]'));
      const option = kind => options.find(input=>input.name.toLowerCase().includes(kind))?.value || '';
      this.frame.contentWindow.postMessage({type:'hanger-preview:update',hanger:option('hanger'),bow:option('bow'),wire:this.value('properties[Wire Color]'),name:this.value('properties[Wire Name]'),left:this.value('properties[Left Arm]'),middle:this.value('properties[Middle Top]'),right:this.value('properties[Right Arm]')},this.url.origin);
    }
    show() {
      this.panel.hidden=false;this.openButton.hidden=true;
      if(!this.started){this.started=true;this.frame.srcdoc=window.HangerPreviewDocument.replace('__PARENT_ORIGIN_JSON__',JSON.stringify(location.origin)).replace('class="photo"','class="photo" data-preview-pinch-zoom') + '<script src="'+this.dataset.zoomScript+'"></script>';this.loadTimer=setTimeout(()=>this.fail(),15000);}
      this.position();this.send();this.keepInputVisible();
    }
    fail(){this.status.textContent=this.querySelector('.hlp-error').textContent;this.status.hidden=false;}
    position() {
      if(this.panel.hidden) return;
      const viewport=window.visualViewport;
      const width=viewport?.width||innerWidth, height=viewport?.height||innerHeight, top=viewport?.offsetTop||0;
      const compact=width<1000;
      const panelWidth=compact?Math.min(width-24,Math.max(210,(height-165)*1.5),380):Math.min(660,width*0.585);
      this.panel.style.width=panelWidth+'px';
      this.panel.style.left=compact?(width-panelWidth)/2+'px':'16px';
      this.panel.style.top=compact?top+8+'px':Math.max(top+12,top+height-this.panel.offsetHeight-24)+'px';
      if(!compact&&this.activeControl){
        const a=this.activeControl.getBoundingClientRect(),p=this.panel.getBoundingClientRect();
        if(a.left<p.right&&a.right>p.left&&a.top<p.bottom&&a.bottom>p.top)this.panel.style.top=top+12+'px';
      }
    }
    keepInputVisible(){
      if(this.panel.hidden||!this.activeControl||!this.activeControl.isConnected)return;
      const a=this.activeControl.getBoundingClientRect(),p=this.panel.getBoundingClientRect();
      if(a.left<p.right&&a.right>p.left&&a.top<p.bottom+12&&a.bottom>p.top)window.scrollBy({top:a.top-p.bottom-16,behavior:'instant'});
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;clearTimeout(this.updateTimer);clearTimeout(this.loadTimer);}
  });
}
